import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=0b6ad94e&"
import script from "./EditUserForm.vue?vue&type=script&lang=ts&"
export * from "./EditUserForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditUserForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports